const aboutEN = {
  seo: {
    title: "About QuadroCode | Building the Future One Generation at a Time",
    description:
      "QuadroCode is a software company built on family vision, mentorship, and long-term technical growth.",
  },
  hero: {
    eyebrow: "About QuadroCode",
    title: "Building the Future, One Generation at a Time",
    lead:
      "QuadroCode is more than a software development company. It is a long-term mission built on vision, responsibility, and the belief that strong builders are shaped early through real work.",
  },
  story: {
    eyebrow: "The Story Behind QuadroCode",
    title: "From a family idea to a real software company",
    paragraphs: [
      "The name Quadro represents the four children who inspired the company. What began as a simple effort to encourage programming skills became a broader ambition: building practical technology, useful products, and sustainable digital businesses.",
      "Today, two of the four children are already active in the company. One is focused on backend development and system logic. The other is focused on frontend development and user experience. They are not only learning code, they are building professional foundations that will define their future roles in technology.",
    ],
  },
  vision: {
    eyebrow: "Family Vision",
    title: "Why QuadroCode exists",
    quote: "Skills built early become mastery later.",
    paragraphs: [
      "QuadroCode was founded to develop more than technical knowledge. The goal is to shape disciplined problem-solvers, builders, and future entrepreneurs who understand how technology creates value in the real world.",
      "The company is structured for continuity. As the younger two children grow and reach the age of 15, they will join the journey with their own strengths, perspectives, and technical paths.",
    ],
  },
  mentorship: {
    eyebrow: "Mentorship from Experience",
    title: "Leadership through guidance, not spotlight",
    paragraphs: [
      "Behind the journey is a father with decades of technology experience. His work in programming began in 1992 with Assembly, C, and C++, where precision and system-level thinking were essential.",
      "Over time, that foundation evolved into building platforms, software systems, and technology businesses. Today, as the leader of a fintech company, he brings deep expertise in architecture, engineering process, and strategic execution.",
      "At QuadroCode, his role is mentorship. The focus is on coaching the next generation to develop technical discipline, product thinking, and the mindset required to build meaningful software.",
    ],
  },
  learning: {
    eyebrow: "Learning by Building",
    title: "Real projects, real standards, real growth",
    bullets: ["Build real things.", "Solve real problems.", "Deliver real software."],
    paragraphs: [
      "Learning at QuadroCode happens through execution, not theory alone. Every project, from websites and digital platforms to custom software solutions, is both a client deliverable and a training ground for long-term technical growth.",
      "This creates an environment where innovation and education move together, and where quality is treated as a professional standard from day one.",
    ],
  },
  future: {
    eyebrow: "Present and Future Vision",
    title: "Built for today, designed for generations",
    paragraphs: [
      "QuadroCode is currently a focused and ambitious software company. The long-term vision is to grow into a family-driven technology studio that combines young creativity with experienced engineering leadership.",
      "As all four children become active contributors over time, QuadroCode will fully represent what its name stands for: four minds building the future together.",
    ],
    missionTitle: "Our Mission",
    missionText:
      "To create practical, reliable software solutions while nurturing the next generation of technology builders. The best way to prepare for the future is to start building it today.",
  },
  cta: {
    eyebrow: "Start the conversation",
    title: "Work with a team building software with long-term purpose",
    text:
      "If you are looking for a thoughtful software partner with a clear vision and a serious engineering mindset, QuadroCode is ready to collaborate.",
    primary: "Discuss Your Project",
    secondary: "Explore Services",
  },
};

export default aboutEN;
